import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useReducer } from 'react';
const initialState = {
    theme: 'light',
    language: 'es',
    notifications: [],
    loading: false,
};
const globalStateReducer = (state, action) => {
    switch (action.type) {
        case 'SET_THEME':
            return { ...state, theme: action.payload };
        case 'SET_LANGUAGE':
            return { ...state, language: action.payload };
        case 'ADD_NOTIFICATION':
            return {
                ...state,
                notifications: [
                    ...state.notifications,
                    {
                        ...action.payload,
                        id: Date.now().toString(),
                        timestamp: new Date(),
                    },
                ],
            };
        case 'REMOVE_NOTIFICATION':
            return {
                ...state,
                notifications: state.notifications.filter(n => n.id !== action.payload),
            };
        case 'SET_LOADING':
            return { ...state, loading: action.payload };
        case 'CLEAR_NOTIFICATIONS':
            return { ...state, notifications: [] };
        default:
            return state;
    }
};
const GlobalStateContext = createContext(undefined);
export const GlobalStateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(globalStateReducer, initialState);
    const addNotification = (notification) => {
        dispatch({ type: 'ADD_NOTIFICATION', payload: notification });
        // Auto-remove notification after 5 seconds
        setTimeout(() => {
            dispatch({ type: 'REMOVE_NOTIFICATION', payload: Date.now().toString() });
        }, 5000);
    };
    const removeNotification = (id) => {
        dispatch({ type: 'REMOVE_NOTIFICATION', payload: id });
    };
    const setTheme = (theme) => {
        dispatch({ type: 'SET_THEME', payload: theme });
    };
    const setLanguage = (language) => {
        dispatch({ type: 'SET_LANGUAGE', payload: language });
    };
    const setLoading = (loading) => {
        dispatch({ type: 'SET_LOADING', payload: loading });
    };
    const value = {
        state,
        dispatch,
        addNotification,
        removeNotification,
        setTheme,
        setLanguage,
        setLoading,
    };
    return (_jsx(GlobalStateContext.Provider, { value: value, children: children }));
};
export const useGlobalState = () => {
    const context = useContext(GlobalStateContext);
    if (context === undefined) {
        throw new Error('useGlobalState must be used within a GlobalStateProvider');
    }
    return context;
};
